"use client";
import { useFetchTestimonials } from "./useFetchTestimonials";
import { getClientDomain } from "./useFetchUnits";
import { useDotButton } from "../components/templates/design2/components/SimilarPosts2";
import { useEffect, useCallback, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";
import { logEnvironment } from "@components/lib/utils";
export const useTestimonialsCarousel = () => {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: false,
    align: "start",
    slidesToScroll: "auto",
  });

  const { selectedIndex, scrollSnaps, onDotButtonClick } =
    useDotButton(emblaApi);

  const [canScrollPrev, setCanScrollPrev] = useState(false);
  const [canScrollNext, setCanScrollNext] = useState(false);

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setCanScrollPrev(emblaApi.canScrollPrev());
    setCanScrollNext(emblaApi.canScrollNext());
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;
    emblaApi.on("select", onSelect);
    onSelect(); // trigger on mount
  }, [emblaApi, onSelect]);

  const location = getClientDomain("fteching testiomials"); // client-safe
  logEnvironment("this the fetch testimonials componennt");

  const {
    data: testimonials,
    isLoading,
    isError,
  } = useFetchTestimonials(location);

  return {
    emblaRef,
    emblaApi,
    selectedIndex,
    scrollSnaps,
    onDotButtonClick,
    canScrollPrev,
    canScrollNext,
    testimonials,
    isLoading,
    isError,
  };
};
